module.exports = __webpack_public_path__ + "img/emoji_68.5bcf2ace.png";